export const addEmblaDotClickHandlers = (emblaApi, dotsNode) => {
	dotsNode.forEach((dot, index) => {
		dot.addEventListener(
			'click',
			() => {
				emblaApi.scrollTo(index);
			},
			false
		);
	});

	const toggleDotsCurrent = () => {
		const previous = emblaApi.previousScrollSnap();
		const selected = emblaApi.selectedScrollSnap();
		dotsNode[previous].classList.remove('current');
		dotsNode[selected].classList.add('current');
	};

	emblaApi.on('init', toggleDotsCurrent).on('reInit', toggleDotsCurrent).on('select', toggleDotsCurrent);
};

export const addEmblaPrevNextClickHandlers = (emblaApi, prevBtn, nextBtn) => {
	prevBtn.addEventListener(
		'click',
		() => {
			emblaApi.scrollPrev();
		},
		false
	);
	nextBtn.addEventListener(
		'click',
		() => {
			emblaApi.scrollNext();
		},
		false
	);

	const togglePrevNextBtnsState = () => {
		if (emblaApi.canScrollPrev()) {
			prevBtn.removeAttribute('disabled');
		} else {
			prevBtn.setAttribute('disabled', 'disabled');
		}

		if (emblaApi.canScrollNext()) {
			nextBtn.removeAttribute('disabled');
		} else {
			nextBtn.setAttribute('disabled', 'disabled');
		}
	};

	emblaApi.on('select', togglePrevNextBtnsState).on('init', togglePrevNextBtnsState).on('reInit', togglePrevNextBtnsState);
};
